import type { EduExpenseCategory } from './edu-expense-category.model';
import type { EduExpensePurpose } from './edu-expense-purpose.model';
import type { TransactionUser } from './transaction.model';

export interface EduExpense {
  id: number;
  user: TransactionUser;
  budget: BudgetType;
  category?: EduExpenseCategory;
  purpose?: EduExpensePurpose;
  amount: number;
  totalBudgetBefore: number;
  totalBudgetAfter: number;
  totalBudgetOverCap: number;
  dateUsed: string;
  description?: string;
  productiveLink?: string;
}

export enum BudgetType {
  EDU = 'EDU',
  EQU = 'EQU',
}

export interface ImportEduBudget {
  spreadsheet: File;
}

export interface CreateEduExpense {
  userId: number;
  budgetType: BudgetType;
  categoryId: number;
  purposeId: number;
  date: string;
  amount: number;
  description?: string;
  productiveLink?: string;
  currency?: string;
}

export interface EditEduExpense {
  userId: number;
  budgetType: BudgetType;
  categoryId: number;
  purposeId: number;
  date: string;
  amount: number;
  description?: string;
}

export interface EduExpenseListFilter {
  [EduExpenseFilters.budgetType]?: BudgetType;
  [EduExpenseFilters.expenseCategoryId]?: number;
  [EduExpenseFilters.expensePurposeId]?: number;
  [EduExpenseFilters.dateFrom]?: string;
  [EduExpenseFilters.dateTo]?: string;
  [EduExpenseFilters.name]?: string;
}

export const EduExpenseFilters = {
  budgetType: 'budgetType',
  expenseCategoryId: 'expenseCategoryId',
  expensePurposeId: 'expensePurposeId',
  dateFrom: 'dateFrom',
  dateTo: 'dateTo',
  name: 'name',
} as const;

export type EduExpenseFilter = keyof typeof EduExpenseFilters;
